module.exports = __webpack_public_path__ + "static/20-780ae1dafe24befe65cbb6165aa5d989.jpg";